import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const enableDeviceAuth = {
  name: "enableDeviceAuth" as const,
  input: z.object({
    deviceName: z.string().min(1).max(100),
    userAgent: z.string().optional(),
  }),
  output: z.object({
    refreshToken: z.string(),
    accessToken: z.string(),
    expiresAt: zExt.instant(), // Access token expiration
    deviceId: z.string(),
  }),
};
